import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

// Import sticker images for carousel (WebP + PNG fallback)
import aaronSticker from "@/assets/aaron.png";
import aaronStickerWebp from "@/assets/aaron.webp";
import deskMatSticker from "@/assets/deskmat.png";
import deskMatStickerWebp from "@/assets/deskmat.webp";
import candleSticker from "@/assets/candle.png";
import candleStickerWebp from "@/assets/candle.webp";
import dumpsterSticker from "@/assets/dumpster.png";
import dumpsterStickerWebp from "@/assets/dumpster.webp";
import githubSticker from "@/assets/github.png";
import githubStickerWebp from "@/assets/github.webp";
import happydaySticker from "@/assets/happyday.png";
import happydayStickerWebp from "@/assets/happyday.webp";
import islandSticker from "@/assets/island.png";
import islandStickerWebp from "@/assets/island.webp";
import localvibeSticker from "@/assets/localvibe.png";
import localvibeStickerWebp from "@/assets/localvibe.webp";
import wakeupSticker from "@/assets/wakeup.png";
import wakeupStickerWebp from "@/assets/wakeup.webp";
import pizzaboySticker from "@/assets/pizzaboy.png";
import pizzaboyStickerWebp from "@/assets/pizzaboy.webp";
import vitaminSticker from "@/assets/vitamins.png";
import vitaminStickerWebp from "@/assets/vitamins.webp";
import weddingDaySticker from "@/assets/weddingday.png";
import weddingDayStickerWebp from "@/assets/weddingday.webp";
import apocolypseSticker from "@/assets/apocolypse.png";
import apocolypseStickerWebp from "@/assets/apocolypse.webp";
import meditationSticker from "@/assets/meditation.png";
import meditationStickerWebp from "@/assets/meditation.webp";
import carsonSticker from "@/assets/carson.png";
import carsonStickerWebp from "@/assets/carson.webp";

const stickerImages = [
  {
    id: 1,
    src: pizzaboySticker,
    webpSrc: pizzaboyStickerWebp,
    alt: "Pizza Boy Sticker",
    prompt: "Boy who eats so much pizza his face is a pizza",
  },
  {
    id: 2,
    src: vitaminSticker,
    webpSrc: vitaminStickerWebp,
    alt: "Trump Sticker",
    prompt: "The president as a Mike Tyson's Punch Out character",
  },
  {
    id: 3,
    src: weddingDaySticker,
    webpSrc: weddingDayStickerWebp,
    alt: "Wedding Day Sticker",
    prompt: "Convert my wedding photo to a cartoon style",
  },
  {
    id: 4,
    src: apocolypseSticker,
    webpSrc: apocolypseStickerWebp,
    alt: "Apocolypse Sticker",
    prompt: "Windows XP background as if it was an apocolypse",
  },
  {
    id: 5,
    src: meditationSticker,
    webpSrc: meditationStickerWebp,
    alt: "Meditation Sticker",
    prompt: "A woman doing yoga in a forest with the sun rising",
  },
  {
    id: 6,
    src: carsonSticker,
    webpSrc: carsonStickerWebp,
    alt: "Carson Sticker",
    prompt: "Boy just graduated from high school and is looking forward to college",
  },
  {
    id: 7,
    src: deskMatSticker,
    webpSrc: deskMatStickerWebp,
    alt: "Desk Mat Sticker",
    prompt: "Ninja Turtles dressed as santa claus and elves",
  },
  {
    id: 8,
    src: dumpsterSticker,
    webpSrc: dumpsterStickerWebp,
    alt: "Dumpster Sticker",
    prompt: "Man running away from a dumpster on fire",
  },
  {
    id: 9,
    src: aaronSticker,
    webpSrc: aaronStickerWebp,
    alt: "Hellbender Sticker",
    prompt: "Novel prize winning scientist that measures tails of salamanders",
  },
  {
    id: 10,
    src: githubSticker,
    webpSrc: githubStickerWebp,
    alt: "GitHub Sticker",
    prompt: "GitHub octocat on a smoke break",
  },
  {
    id: 11,
    src: happydaySticker,
    webpSrc: happydayStickerWebp,
    alt: "Happy Day",
    prompt: "Happy Day with a dad and his daughters",
  },
  {
    id: 12,
    src: islandSticker,
    webpSrc: islandStickerWebp,
    alt: "Island Sticker",
    prompt: "Man and his wife on an island without water",
  },
  {
    id: 13,
    src: candleSticker,
    webpSrc: candleStickerWebp,
    alt: "Candle Sticker",
    prompt: "Candle with a little girl",
  },
  {
    id: 14,
    src: localvibeSticker,
    webpSrc: localvibeStickerWebp,
    alt: "Local Vibe Sticker",
    prompt: "Local Vibe with a girl and a dog",
  },
  {
    id: 16,
    src: wakeupSticker,
    webpSrc: wakeupStickerWebp,
    alt: "Wake Up Sticker",
    prompt: "Comic book style of wife telling husband to wake up",
  },
];

export function StickerCarouselSection() {
  return (
    <div className="max-w-6xl mx-auto px-4">
      <Swiper
        modules={[Autoplay]}
        spaceBetween={30}
        slidesPerView={4}
        loop={true}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          320: { slidesPerView: 1, spaceBetween: 20 },
          640: { slidesPerView: 2, spaceBetween: 20 },
          768: { slidesPerView: 3, spaceBetween: 30 },
          1024: { slidesPerView: 4, spaceBetween: 30 },
        }}
      >
        {stickerImages.map(sticker => (
          <SwiperSlide key={sticker.id}>
            <div
              className="bg-background rounded-xl shadow-md p-4 flex flex-col items-center justify-between hover:shadow-lg transition-shadow"
              style={{ height: "340px" }}
            >
              <div
                className="w-full flex items-center justify-center overflow-hidden"
                style={{ height: "210px" }}
              >
                <picture>
                  <source srcSet={sticker.webpSrc} type="image/webp" />
                  <img
                    src={sticker.src}
                    alt={sticker.alt}
                    width={210}
                    height={210}
                    loading="lazy"
                    className="max-h-full max-w-full object-contain"
                    style={{ display: "block", margin: "0 auto" }}
                  />
                </picture>
              </div>
              <div className="mt-4 text-center min-h-[40px] flex items-center justify-center w-full">
                <p className="text-sm text-muted-foreground line-clamp-2 w-full">
                  {sticker.prompt}
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
